/* TSH rope setup choice + cart handles reminder */
if (!customElements.get("tsh-rope-setup")) {
  customElements.define(
    "tsh-rope-setup",
    class TshRopeSetup extends HTMLElement {
      connectedCallback() {
        this.scope =
          this.closest("product-info") ||
          this.closest(".shopify-section") ||
          document.body;
        this.priceEl = document.getElementById("Price-" + this.dataset.section);
        this.originalPriceHTML = this.priceEl ? this.priceEl.innerHTML : "";
        this.ropeVariant = this.readSelectedVariant();
        this.addEventListener("change", (e) => {
          if (e.target.name === "tsh_setup") this.sync();
          if (e.target.name === "tsh_handle_variant") this.sync();
        });
        if (typeof webvista !== "undefined" && typeof PUB_SUB_EVENTS !== "undefined") {
          this.unsubscribe = webvista.subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (!event || !event.data || event.data.sectionId !== this.dataset.section) return;
            // The theme just replaced the price block for the new variant.
            this.priceEl = document.getElementById("Price-" + this.dataset.section);
            this.originalPriceHTML = this.priceEl ? this.priceEl.innerHTML : "";
            if (event.data.variant) this.ropeVariant = event.data.variant;
            this.sync();
          });
        }
        this.sync();
      }
      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }
      readSelectedVariant() {
        const script = this.scope.querySelector("script[data-selected-variant]");
        try {
          if (script) return JSON.parse(script.textContent);
        } catch (e) {}
        const price = parseInt(this.dataset.ropePrice || "", 10);
        if (isNaN(price)) return null;
        const compare = parseInt(this.dataset.ropeCompare || "0", 10);
        return { price, compare_at_price: compare > price ? compare : null };
      }
      get mode() {
        const checked = this.querySelector('input[name="tsh_setup"]:checked');
        return checked ? checked.value : "rope_only";
      }
      get handle() {
        const select = this.querySelector("select[name=tsh_handle_variant]");
        const el = select ? select.options[select.selectedIndex] : this.querySelector("input[name=tsh_handle_variant]");
        return el ? { cents: parseInt(el.dataset.cents || "0", 10), price: el.dataset.price, name: el.dataset.name } : null;
      }
      formatMoney(cents) {
        const format = this.dataset.moneyFormat || "${{amount}}";
        const fmt = (n, d, t, dec) => {
          const fixed = (n / 100).toFixed(d);
          const [whole, frac] = fixed.split(".");
          const w = whole.replace(/\B(?=(\d{3})+(?!\d))/g, t);
          return frac ? w + dec + frac : w;
        };
        return format.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
          switch (key) {
            case "amount_no_decimals": return fmt(cents, 0, ",", ".");
            case "amount_with_comma_separator": return fmt(cents, 2, ".", ",");
            case "amount_no_decimals_with_comma_separator": return fmt(cents, 0, ".", ",");
            case "amount_with_apostrophe_separator": return fmt(cents, 2, "'", ".");
            default: return fmt(cents, 2, ",", ".");
          }
        });
      }
      sync() {
        const complete = this.mode === "complete";
        const hideExpress = this.dataset.hideExpress === "true" && complete;
        this.scope.classList.toggle("tsh-setup--complete", hideExpress);
        const handle = this.handle;
        const v = this.ropeVariant;
        const checked = this.querySelector('input[name="tsh_setup"]:checked');
        const labelEl = this.querySelector("[data-tsh-selected-label]");
        if (labelEl && checked) labelEl.textContent = checked.dataset.label || "";
        const panel = this.querySelector("[data-tsh-handles-panel]");
        if (panel) panel.hidden = !complete;
        if (v && typeof v.price === "number") {
          const ropeEl = this.querySelector("[data-tsh-rope-price]");
          if (ropeEl) ropeEl.textContent = this.formatMoney(v.price);
          const totalEl = this.querySelector("[data-tsh-total-price]");
          if (totalEl && handle) totalEl.textContent = this.formatMoney(v.price + handle.cents);
        }
        const select = this.querySelector("select[name=tsh_handle_variant]");
        const thumb = this.querySelector("[data-tsh-handle-thumb]");
        if (select && thumb) {
          const opt = select.options[select.selectedIndex];
          if (opt && opt.dataset.img) {
            if (thumb.getAttribute("src") !== opt.dataset.img) thumb.src = opt.dataset.img;
            thumb.hidden = false;
          } else {
            thumb.hidden = true;
          }
          if (opt && opt.dataset.alt) thumb.alt = opt.dataset.alt;
        }
        this.renderPrice(complete, handle);
      }
      renderPrice(complete, handle) {
        if (!this.priceEl || this.dataset.updatePrice !== "true") return;
        this.priceEl.innerHTML = this.originalPriceHTML;
        const v = this.ropeVariant;
        if (!complete || !handle || !v || typeof v.price !== "number") return;
        const sale = this.priceEl.querySelector(".price-item--sale");
        const current = sale || this.priceEl.querySelector(".price-item--regular");
        if (current) current.textContent = this.formatMoney(v.price + handle.cents);
        if (sale && v.compare_at_price) {
          const compare = this.priceEl.querySelector(".price-item--regular");
          if (compare) compare.textContent = this.formatMoney(v.compare_at_price + handle.cents);
        }
        const tpl = this.dataset.breakdown || "";
        if (tpl.trim()) {
          const line = document.createElement("p");
          line.className = "tsh-rope-setup__breakdown";
          line.textContent = tpl
            .replace("[rope]", this.formatMoney(v.price))
            .replace("[handles]", this.formatMoney(handle.cents));
          this.priceEl.appendChild(line);
        }
      }
    },
  );
}

if (!customElements.get("tsh-handles-reminder")) {
  customElements.define(
    "tsh-handles-reminder",
    class TshHandlesReminder extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector("button[data-variant-id]");
        if (!this.button || this.button.dataset.bound) return;
        this.button.dataset.bound = "true";
        this.button.addEventListener("click", this.add.bind(this));
      }
      add() {
        const cartItems =
          this.closest("[id$='-Details']")?.querySelector("cart-items") ||
          document.querySelector("cart-items");
        const sections =
          cartItems && typeof cartItems.getSectionsToRender === "function"
            ? cartItems.getSectionsToRender()
            : [];
        this.button.setAttribute("disabled", "disabled");
        this.button.classList.add("loading");
        fetch(window.routes.cart_add_url, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({
            items: [
              {
                id: Number(this.button.dataset.variantId),
                quantity: Math.max(1, parseInt(this.button.dataset.quantity || "1", 10)),
              },
            ],
            sections: sections.map((s) => s.section),
            sections_url: window.location.pathname,
          }),
        })
          .then((r) => r.json())
          .then((res) => {
            if (res.status) {
              if (typeof webvista !== "undefined" && webvista.popToast) webvista.popToast(res.description || res.message, "error");
              return;
            }
            if (sections.length && typeof SectionDynamicUpdate !== "undefined" && res.sections) {
              SectionDynamicUpdate.updateSections(sections, res.sections);
            } else {
              window.location.reload();
              return;
            }
            if (typeof webvista !== "undefined" && typeof PUB_SUB_EVENTS !== "undefined") {
              webvista.publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "tsh-handles-reminder",
                productVariantId: Number(this.button.dataset.variantId),
                cartData: res,
              });
            }
          })
          .catch(() => window.location.reload())
          .finally(() => {
            if (this.isConnected) {
              this.button.removeAttribute("disabled");
              this.button.classList.remove("loading");
            }
          });
      }
    },
  );
}

if (!customElements.get("tsh-size-guide")) {
  customElements.define(
    "tsh-size-guide",
    class TshSizeGuide extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.toggle = this.querySelector(".tsh-size-guide__toggle");
        this.panel = this.querySelector(".tsh-size-guide__panel");
        this.hint = this.querySelector("[data-tsh-size-hint]");
        if (this.toggle && this.panel) {
          this.toggle.addEventListener("click", () => {
            const open = this.toggle.getAttribute("aria-expanded") !== "true";
            this.toggle.setAttribute("aria-expanded", String(open));
            this.panel.hidden = !open;
          });
        }
        this.onChange = (e) => {
          const t = e.target;
          if (!t || t.name !== this.dataset.option) return;
          if (this.dataset.form && t.getAttribute("form") !== this.dataset.form && !t.closest("#" + this.dataset.form)) return;
          this.update(t.value);
        };
        document.addEventListener("change", this.onChange);
        const checked = document.querySelector(
          'input[name="' + CSS.escape(this.dataset.option) + '"][form="' + this.dataset.form + '"]:checked',
        );
        this.update(checked ? checked.value : this.dataset.selected);
      }
      disconnectedCallback() {
        if (this.onChange) document.removeEventListener("change", this.onChange);
        this.bound = false;
      }
      update(size) {
        let range = "";
        this.querySelectorAll(".tsh-size-guide__row").forEach((row) => {
          const active = row.dataset.size === size;
          row.classList.toggle("is-active", active);
          if (active) range = row.dataset.range;
        });
        if (!this.hint) return;
        this.hint.textContent = range
          ? (this.dataset.hint || "[size] for heights [range]").replace("[size]", size).replace("[range]", range)
          : "";
      }
    },
  );
}
